import { type ReactNode } from 'react'
import styled from '@emotion/styled'

import { FormProvider, useForm } from 'react-hook-form'
import { useTitle } from 'react-use'

import { StyledImage } from 'consumer-mobile-web/components/CompanyLogo/CompanyLogo'
import { MobilePage } from 'consumer-mobile-web/components/Intake/Containers'
import Footer from 'consumer-mobile-web/components/Footer'

import colors from 'design-system/tokens/colors'
import fontSizes from 'design-system/tokens/fontSizes'
import fontWeights from 'design-system/tokens/fontWeights'
import spacing from 'design-system/tokens/spacing'

import Success from './screens/Success'
import Create from './screens/Create'
import useHistoryState from './hooks/useHistoryState'

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${colors.white};
`

const Header = styled.div`
  padding: ${spacing.xs} ${spacing.s};
  border-bottom: 1px solid ${colors.grays.l5};
  display: flex;
  align-items: center;
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.h3};
  font-weight: ${fontWeights.bold};
  color: ${colors.black};
`

type Props = {
  children: ReactNode
}

const DirectMobileWebLayout = ({ children }: Props) => {
  useTitle('Need Roadside Assistance?')

  const methods = useForm({
    defaultValues: {
      phoneNumber: window.sessionStorage.getItem('directMWI-phoneNumber') || '',
      name: '',
    },
    mode: 'onBlur',
  })
  const logoUrl = window.gon ? window.gon.client_company_url : ''

  return (
    <MobilePage>
      <Container>
        <Header>
          {logoUrl ? (
            <StyledImage src={logoUrl} variant="header" />
          ) : (
            <Logo>{window.gon ? window.gon.client_name : ''}</Logo>
          )}
        </Header>

        <FormProvider {...methods}>{children}</FormProvider>
      </Container>
      <Footer />
    </MobilePage>
  )
}

const App = () => {
  const { showSuccessScreen, navigateToSuccess } = useHistoryState()

  return (
    <DirectMobileWebLayout>
      <Layout>{showSuccessScreen ? <Success /> : <Create onSuccess={navigateToSuccess} />}</Layout>
    </DirectMobileWebLayout>
  )
}

export default App
